import React from 'react';
import { Link } from 'react-router-dom';
import { get } from 'lodash';
import { CardWrapper } from 'components/company/FulltimeRecruitmentCard';
import { useTimezone } from 'libs/hooks';
import { TRecruitment } from 'modules/main';
import { ERoute } from 'enums/route.enum';
import { Col, Row, Card, Avatar } from 'antd';
import { RightOutlined } from '@ant-design/icons/lib';
import { PrimaryColor } from 'GlobalStyles';

const { Meta } = Card;
type TRecruitmentCardProps = {
  data: TRecruitment;
  showIntern?: boolean;
};
const ParttimeRecruitmentCard = ({ data, showIntern = false }: TRecruitmentCardProps) => {
  const periodFormat = 'YYYY.M.D';
  const [getDateTime, timezone] = useTimezone();

  return (
    <CardWrapper>
      <Card
        cover={
          <Link to={`${ERoute.CompanyParttimeView.replace(':record_id', String(get(data, 'id')))}`}>
            {get(data, 'is_closed', false) === true && (
              <>
                <div className='center-text'>모집 마감</div>
                <div className='ant-avatar-square opacity-background'></div>
              </>
            )}
            <Avatar shape='square' src={get(data, 'logo_url')} />
          </Link>
        }
      >
        <Meta
          title={
            <Link to={`${ERoute.CompanyParttimeView.replace(':record_id', String(get(data, 'id')))}`}>
              <div style={{ color: '#000' }}>{get(data, 'title')}</div>
            </Link>
          }
          description={
            <>
              {showIntern === true && (
                <Row justify='space-between'>
                  <Col style={{ color: `${PrimaryColor}` }}>인턴 채용</Col>
                </Row>
              )}
              <Row justify='space-between'>
                <Col flex='70px' style={{ color: '#14112A' }}>
                  근무 기간
                </Col>
                {get(data, 'employment_from') ? (
                  <Col flex='auto' className='card-value'>
                    {getDateTime(get(data, 'employment_from'))
                      .format(periodFormat)
                      .replace('PM', '오후')
                      .replace('AM', '오전')}
                    &nbsp; ~&nbsp;
                    {getDateTime(get(data, 'employment_to'))
                      .format(periodFormat)
                      .replace('PM', '오후')
                      .replace('AM', '오전')}
                    &nbsp;&nbsp;
                    {get(data, 'duration')}주간
                  </Col>
                ) : (
                  <Col flex='auto' className='card-value'>
                    ASAP&nbsp;~&nbsp;
                    {getDateTime(get(data, 'employment_to')).format(periodFormat)}
                    &nbsp;&nbsp;{get(data, 'duration')}주간
                  </Col>
                )}
              </Row>
              <Row justify='space-between'>
                <Col flex='70px' style={{ color: '#14112A' }}>
                  담당자
                </Col>
                <Col flex='auto' className='card-value'>
                  {get(data, 'responsible_name')}
                </Col>
              </Row>
            </>
          }
        />
      </Card>
      <Link
        to={`${ERoute.CompanyParttimeView.replace(':record_id', String(get(data, 'id')))}`}
        className='action'
      >
        <Row justify='space-between'>
          <Col>더보기</Col>
          <Col>
            <RightOutlined />
          </Col>
        </Row>
      </Link>
    </CardWrapper>
  );
};

export default ParttimeRecruitmentCard;
